import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import { getNearestShape } from '../utils/functions';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AmenitiesSelector = observer(({ interactiveRef }) => {
    const { mapStore, mainStore } = useStores();

    const { s3Url } = mainStore.config || {};

    const sliderRef = useRef(null);

    const [currentSlide, setCurrentSlide] = useState(0);
    const [itemsPerSlide, setItemsPerSlide] = useState(6);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) {
                setItemsPerSlide(4);
            } else {
                setItemsPerSlide(6);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const chunkedAmenities = [];
    for (let i = 0; i < mainStore.listAmenities.length; i += itemsPerSlide) {
        chunkedAmenities.push(
            mainStore.listAmenities.slice(i, i + itemsPerSlide)
        );
    }

    const totalSlides = chunkedAmenities.length;

    useEffect(() => {
        if (mainStore.progressLoadApp) {
            if (sliderRef.current) {
                sliderRef.current.slickGoTo(0);
            }
        }
    }, [mainStore.isScreensaverVisible, mainStore.progressLoadApp]);

    const settings = {
        dots: false,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        swipeToSlide: true,
        accessibility: false,
        afterChange: (index) => setCurrentSlide(index),
    };

    const handlePrev = () => {
        sliderRef.current.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current.slickNext();
    };

    const handleClickAmenities = async (amenity) => {
        const prevSelectedAmenity = mainStore.floorguideSelectedAmenity;
        if (prevSelectedAmenity === amenity._id) {
            mainStore.setFloorguideSelectedAmenity(null);
        } else {
            mainStore.setFloorguideSelectedAmenity(amenity._id);
        }

        const amenityPois = mainStore.amenities.filter((poiAmenity) =>
            amenity.associatedPois.includes(poiAmenity._id)
        );
        // }

        if (!amenityPois && amenityPois.length === 0) {
            mapStore.setCurrentFreeShape([]);
            return;
        }

        [...mapStore.freeShapes, ...mapStore.model3ds].forEach((e) => {
            interactiveRef.current.changeTopImage(e._id, null);
        });

        const amenityShapes = mapStore.freeShapes.filter((data) =>
            amenityPois.some(
                (poi) =>
                    poi.locations?.some((loc) => loc.id === data._id) ||
                    poi.locations?.some((loc) => loc._id === data._id)
            )
        );

        const amenityModel3ds = mapStore.model3ds.filter((data) =>
            amenityPois.some(
                (poi) =>
                    poi.locations?.some((loc) => loc.id === data._id) ||
                    poi.locations?.some((loc) => loc._id === data._id)
            )
        );

        const amenityCurrentShapes = [...amenityShapes, ...amenityModel3ds];

        const nearestShape = await getNearestShape(
            mapStore,
            amenityShapes,
            'not-disabled'
        );

        if (prevSelectedAmenity === amenity._id) {
            mapStore.currentFreeShape.forEach((e) => {
                interactiveRef.current.changeTopImage(e._id, null);
            });

            mapStore.setCurrentFreeShape([]);
        } else {
            mapStore.setCurrentFreeShape(amenityCurrentShapes);

            if (nearestShape) {
                try {
                    interactiveRef.current.focusOnShape(nearestShape, 50);
                } catch {
                    interactiveRef.current.changeActiveFloor(
                        nearestShape.floorId,
                        false
                    );
                }
            } else {
                if (amenityCurrentShapes?.length === 1) {
                    interactiveRef.current.focusOnShape(
                        amenityCurrentShapes[0],
                        50
                    );
                } else {
                    interactiveRef.current.changeActiveFloor(
                        mapStore.defaultFloorId,
                        false
                    );
                }
            }

            amenityPois.forEach((am) => {
                const activeImageAmenity =
                    am.firstMedias && am.firstMedias.length > 0
                        ? am.firstMedias[0]
                        : '';

                mapStore.currentFreeShape.forEach((e) => {
                    interactiveRef.current.changeTopImage(
                        e._id,
                        `/map-data/adsign-cms/pois/${activeImageAmenity}`
                    );
                });
            });
        }
    };

    const ButtonArrow = ({ type = 'prev' }) => {
        const isUnclickable =
            type === 'prev'
                ? currentSlide === 0
                : currentSlide === totalSlides - 1;
        return (
            <div
                onClick={type === 'prev' ? handlePrev : handleNext}
                className={`flex justify-center items-center w-[26px] sm:w-8 h-auto overflow-hidden ${
                    !isUnclickable && 'cursor-pointer'
                }`}
            >
                <img
                    alt=""
                    src={require(`../img/${
                        type === 'next'
                            ? isUnclickable
                                ? 'RightArr_Inactive.png'
                                : 'RightArr_Active.png'
                            : isUnclickable
                            ? 'LeftArr_Inactive.png'
                            : 'LeftArr_Active.png'
                    }`)}
                />
            </div>
            // <button
            //     type="button"
            //     className={`flex justify-center items-center w-[22px] h-10 sm:w-7 md:w-10 sm:h-12 md:h-[96px] bg-[#F7F6F6] border-[1px] overflow-hidden ${
            //         isUnclickable ? 'border-[#E4E4E4]' : 'border-[#FF6200]'
            //     }`}
            //     style={{ backdropFilter: 'blur(20px)' }}
            //     onClick={type === 'prev' ? handlePrev : handleNext}
            // >
            //     <img src={require('../img/LeftArr_Active.png')} />
            //     <svg
            //         className={type === 'next' && 'rotate-180'}
            //         width="22"
            //         height="22"
            //         viewBox="0 0 22 22"
            //         fill="none"
            //         xmlns="http://www.w3.org/2000/svg"
            //     >
            //         <path
            //             d="M14.4321 6.688L8.93215 12.188L7.7002 11L13.2002 5.5L14.4321 6.688Z"
            //             fill={isUnclickable ? '#949494' : '#F26322'}
            //         />
            //         <path
            //             fill-rule="evenodd"
            //             clip-rule="evenodd"
            //             d="M13.2441 16.5004L14.4321 15.3124L10.5602 11.4844L9.37207 12.6724L13.2441 16.5004Z"
            //             fill={isUnclickable ? '#949494' : '#F26322'}
            //         />
            //     </svg>
            // </button>
        );
    };

    return (
        <div className="relative flex justify-center items-center gap-1 w-screen sm:w-fit">
            {/* Button Prev */}
            <ButtonArrow />

            {/* List of Amenities */}
            <Slider
                {...settings}
                ref={sliderRef}
                className="amenities-slick h-full w-[75%] sm:w-[450px] md:w-[600px] mx-1 cursor-pointer"
            >
                {chunkedAmenities.map((amenities, slideIndex) => (
                    <div key={slideIndex}>
                        <div className="grid grid-cols-4 grid-rows-1 sm:grid-cols-6 gap-1 sm:gap-1.5 px-1">
                            {amenities.map((amenity) => {
                                const isActive =
                                    amenity._id ===
                                    mainStore.floorguideSelectedAmenity;

                                return (
                                    <button
                                        key={amenity._id}
                                        className="flex justify-center"
                                        onClick={() =>
                                            handleClickAmenities(amenity)
                                        }
                                    >
                                        {amenity.files?.length > 1 && (
                                            <div
                                                className={`flex flex-col items-center justify-center gap-[3px]
                                           h-16 sm:h-16 w-full border border-black
                                           ${
                                               isActive
                                                   ? 'text-white bg-[#FF6200]'
                                                   : 'text-[#263238] bg-white'
                                           }`}
                                            >
                                                <img
                                                    alt=""
                                                    className="h-6 w-6 sm:h-8 sm:w-8"
                                                    src={`${s3Url}/information/${
                                                        isActive
                                                            ? amenity.files[1]
                                                                  .logo
                                                            : amenity.files[0]
                                                                  .logo
                                                    }`}
                                                />
                                                <div
                                                    className="text-center w-full text-[8px] sm:text-[10px] leading-[10px] sm:leading-[12px] font-bold h-6 uppercase"
                                                    dangerouslySetInnerHTML={{
                                                        __html: amenity.description,
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </Slider>

            {/* Button Next */}
            <ButtonArrow type="next" />
        </div>
    );
});

export default AmenitiesSelector;
